<div class="row" style="margin-top:40px">    
    <div class="col-xs-12" style="padding:10px;">
        <div id="outer">
            <div id="summary-container">
                <p class="title-3" style="text-align: center;">Repayment Schedule</p>
                <div class="table-container" >
                    <table mat-table [dataSource]="data" class="mat-elevation-z8">

                        <ng-container matColumnDef="month">
                            <th mat-header-cell *matHeaderCellDef> Month </th>
                            <td mat-cell *matCellDef="let element; let i = index"> {{i}} </td>
                        </ng-container>

                        <ng-container matColumnDef="pmt">
                            <th mat-header-cell *matHeaderCellDef> Total Payment </th>
                            <td mat-cell *matCellDef="let element"> {{(-element.pmt + element.extraPmt) | currency:'GBP':'symbol':'1.0-0'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="intPmt">
                          <th mat-header-cell *matHeaderCellDef> Interest Payment </th>
                          <td mat-cell *matCellDef="let element"> {{element.intPmt | currency:'GBP':'symbol':'1.0-0'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="balance">
                            <th mat-header-cell *matHeaderCellDef> Closing Balance </th>
                            <td mat-cell *matCellDef="let element"> {{element.prinBalPostExtra | currency:'GBP':'symbol':'1.0-0'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="op">
                            <th mat-header-cell *matHeaderCellDef> Over Payment </th>
                            <td mat-cell *matCellDef="let element"> {{element.extraPmt | currency:'GBP':'symbol':'1.0-0'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="prinPmt">
                            <th mat-header-cell *matHeaderCellDef> Principal Payment </th>
                            <td mat-cell *matCellDef="let element"> {{element.prinPmt + element.extraPmt | currency:'GBP':'symbol':'1.0-0'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="ltv">
                            <th mat-header-cell *matHeaderCellDef> Projected LTV </th>
                            <td mat-cell *matCellDef="let element"> {{element.ltv | percent:'1.0'}} </td>
                        </ng-container>

                        <!-- <ng-container matColumnDef="prop">
                            <th mat-header-cell *matHeaderCellDef> Projected Property Value </th>
                            <td mat-cell *matCellDef="let element"> {{element.propertyValue | currency:'GBP':'symbol':'1.0-0'}} </td>
                        </ng-container> -->
                      
                        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                      </table>
                </div>
                <div style="display: flex;flex-direction: row;justify-content:flex-end; margin-top:20px">
                    <button [style.display]="calcService.amended ? 'block' : 'none'" (click)="refresh()" class="submit-button">Refresh</button>
                </div>
            </div>
        </div>
    </div>
</div>